/*======================================================================================================================
  * Bluebell: src/app/state/results-filters/results-filters.actions.ts
  * Last Edited: 13/12/2024
  * Copyright 2024-2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { AvailableResultsFilter, ResultsFilter } from '@state/results-filters/results-filter.interfaces';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ResultsFilterActions = createActionGroup({
  source: 'Results Filters',
  events: {
    'create': (resultsFilter: ResultsFilter) => ({ resultsFilter }),
    'createSuccess': (createdResultsFilter: ResultsFilter) => ({ createdResultsFilter }),
    'createFailure': emptyProps(),

    'loadAvailable': emptyProps(),
    'loadAvailableSuccess': props<{ availableFilters: AvailableResultsFilter[] }>(),
    'loadAvailableFailure': emptyProps(),

    'loadOne': props<AvailableResultsFilter>(),
    'loadOneSuccess': (resultsFilter: ResultsFilter) => ({ resultsFilter }),
    'loadOneFailure': emptyProps(),

    'updateOne': (resultsFilter: ResultsFilter) => ({ resultsFilter }),
    'updateOneSuccess': (updatedResultsFilter: ResultsFilter) => ({ updatedResultsFilter }),
    'updateOneFailure': emptyProps(),

    'renameOne': props<{ resultsFilter: AvailableResultsFilter, name: string }>(),
    'renameOneSuccess': (renamedResultsFilter: ResultsFilter) => ({ renamedResultsFilter }),
    'renameOneFailure': emptyProps(),

    'deleteOne': props<AvailableResultsFilter>(),
    'deleteOneSuccess': props<AvailableResultsFilter>(),
    'deleteOneFailure': emptyProps(),

    'applyFilter': props<ResultsFilter>(),
    'clearFilter': emptyProps(),
    'clear': emptyProps(),
  }
});
